<template>
  <sliding-modal :is-open="isOpen" @secondary="$emit('close')">
    <vk-modal-content>
      <div class="BODY p-3 d-flex">
        <div class="d-flex">
          <vk-icon
              name="exclamation-circle-outlined"
              size="30"
              class="INFO"
          />
        </div>
        <div class="d-flex fd-column">
          <div class="TITLE">Text Messsage Opt-In</div>
          <div class="p-b-2">Pro Referral may send you text messages about this service request.
          Message & data rates may apply.
          Texts message frequency varies and may be sent between 8:00 am & 9:00 pm.
          Text STOP to cancel or HELP for help. For questions, contact 1-855-723-2266.</div>
          <div class="d-flex jc-end">
            <button
                class="btn ROUNDED p-x-3"
                @click.prevent="$emit('close')">
              Ok
            </button>
          </div>
        </div>
      </div>
    </vk-modal-content>
  </sliding-modal>
</template>

<script>
import SlidingModal from '@/views/Dashboard/components/SlidingModal';

export default {
  name: 'sms-modal',
  components: {
    SlidingModal,
  },
  props: {
    isOpen: Boolean,
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";

  .BODY {
    @include responsive(max-width, 100%, 600px);
  }

  .FADE-enter-active,
  .FADE-leave-active {
    opacity: 1;
    will-change: opacity;
    transition: opacity $transition-half-duration;

    &.FADE-enter,
    &.FADE-leave-to {
      opacity: 0;
    }
  }
  .INFO {
    color: #1890FF;
    margin-right: 2*$unit;
  }
  .TITLE {
    font-size: 22px;
    font-weight: 600;
    padding-bottom: $unit;
  }
  .ROUNDED {
  border-radius: 5px;
}
</style>
